const japanPrefectures = {
  hokkaido: '北海道',
  aomori: '青森县',
  iwate: '岩手县',
  miyagi: '宫城县',
  akita: '秋田县',
  yamagata: '山形县',
  fukushima: '福岛县',
  ibaraki: '茨城县',
  tochigi: '栃木县',
  gunma: '群马县',
  saitama: '埼玉县',
  chiba: '千叶县',
  tokyo: '东京都',
  kanagawa: '神奈川县',
  niigata: '新潟县',
  toyama: '富山县',
  ishikawa: '石川县',
  fukui: '福井县',
  yamanashi: '山梨县',
  nagano: '长野县',
  gifu: '岐阜县',
  shizuoka: '静冈县',
  aichi: '爱知县',
  mie: '三重县',
  shiga: '滋贺县',
  kyoto: '京都府',
  osaka: '大阪府',
  hyogo: '兵库县',
  nara: '奈良县',
  wakayama: '和歌山县',
  tottori: '鸟取县',
  shimane: '岛根县',
  okayama: '冈山县',
  hiroshima: '广岛县',
  yamaguchi: '山口县',
  tokushima: '德岛县',
  kagawa: '香川县',
  ehime: '爱媛县',
  kochi: '高知县',
  fukuoka: '福冈县',
  saga: '佐贺县',
  nagasaki: '长崎县',
  kumamoto: '熊本县',
  oita: '大分县',
  miyazaki: '宫崎县',
  kagoshima: '鹿儿岛县',
  okinawa: '冲绳县'
};

export default japanPrefectures;
